// import external dependencies
import 'jquery';

import 'slick-carousel/slick/slick.min';
import 'sharer.js/sharer.min.js';

// Import everything from autoload
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import people from './routes/people';
import { peopleReflow, peopleFilter } from './people';
import gridToggle from './grid-toggle';
import mobileNavToggle from './util/mobile-nav-toggle';
import mobileGallery from './mobile-gallery';
import filter from './filter';
import carousel from './carousel';
import modalNavigation from './modal-navigation';
import ClipboardJS from 'clipboard';
import tippy from 'tippy.js';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  people,
});

// Load Events
jQuery(document).ready(() => {
  routes.loadEvents();
  carousel();
  gridToggle();
  mobileNavToggle();
  mobileGallery();
  filter();
  modalNavigation();
  peopleReflow();
  peopleFilter();

  new ClipboardJS('.btn-social--copy');

  // Add tooltip to .js-clipboard classes used in sharer.js
  tippy('.btn-social--copy', {
    trigger: 'click',
    content: 'Copied!',
    duration: [0, 200],
    hideOnClick: false,
    onShow(instance) {
      setTimeout(() => {
        instance.hide();
      }, 1000);
    },
  });

  window.screenWidth = $(window).width();
});

$(window).on( 'resize', function() {
  if(window.screenWidth !== $(window).width() ) {
    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(function(){
        peopleReflow();
    }, 100);

    window.screenWidth = $(window).width();
  }
});



// WEBPACK FOOTER //
// ./scripts/main.js